import { reportFilters } from '@/modules/reportTemplates/filters'
import { normalizeAggregatedStatusKey, normalizeStageKey } from './ppuStatusHelper'

export function improvementReportFilters(filters: object) {
  const result = reportFilters(filters)
  if (Array.isArray(result.status))
    result.status = result.status.map(value => normalizeAggregatedStatusKey(String(value)))
  if (Array.isArray(result.stages))
    result.stages = result.stages.map(value => normalizeStageKey(String(value)))
  // The list API sends these switches only when enabled.
  if (!result.mine) delete result.mine
  if (!result.my_department) delete result.my_department
  return result
}
